<section class="reports-page">
  <header>
    <div>
      <p>Reporting data warehouse</p>
      <h1>{{ selectedReport().label }} reports</h1>
      <span>Live business intelligence synchronized from operational services.</span>
    </div>
    <div class="actions">
      <label>From<input type="date" [(ngModel)]="from" /></label
      ><label>To<input type="date" [(ngModel)]="to" /></label
      ><button (click)="load()">Apply</button>
      @if (reportType !== 'all' && canExport) {
        <button class="export" [disabled]="exporting" (click)="export('xlsx')">
          <span class="material-symbols-outlined">table_view</span
          >{{ exporting === 'xlsx' ? 'Preparing…' : 'Excel' }}</button
        ><button class="export" [disabled]="exporting" (click)="export('pdf')">
          <span class="material-symbols-outlined">picture_as_pdf</span
          >{{ exporting === 'pdf' ? 'Preparing…' : 'PDF' }}
        </button>
      }
      @if (canSync) { <button class="sync" [disabled]="syncing" (click)="sync()">
        {{ syncing ? 'Syncing…' : 'Sync now' }}
      </button> }
    </div>
  </header>
  <div class="report-layout">
    <aside class="report-sidebar">
      <div class="sidebar-title">Report center</div>
      @for (report of reportTypes; track report.value) {
        <button [class.active]="reportType === report.value" (click)="reportType = report.value">
          <span class="material-symbols-outlined">{{ report.icon }}</span
          ><span>{{ report.label }}</span
          ><span class="material-symbols-outlined arrow">chevron_right</span>
        </button>
      }
    </aside>
    <main class="report-content">
      @if (error) {
        <p class="error">{{ error }}</p>
      }
      @if (loading) {
        <div class="skeleton">
          @for (i of [1, 2, 3, 4, 5, 6]; track i) {
            <i></i>
          }
        </div>
      }
      @if (!loading && data) {
        <div class="sync-state">
          <span class="dot" [class.failed]="data.lastSync?.status === 'Failed'"></span
          ><strong
            >Last sync:
            {{ data.lastSync?.completedAt || data.lastSync?.startedAt || 'Not completed' }}</strong
          ><span
            >{{ data.lastSync?.metricRows || 0 }} reporting rows ·
            {{ data.lastSync?.status || 'Unknown' }}</span
          >
        </div>
        @if (reportType === 'all') {
          <div class="metrics">
            <article>
              <span>Revenue</span><strong>{{ money(metric('revenue')) }}</strong>
            </article>
            <article>
              <span>Orders</span><strong>{{ number(metric('orders.created')) }}</strong>
            </article>
            <article>
              <span>Purchases</span><strong>{{ money(metric('purchases')) }}</strong>
            </article>
            <article>
              <span>Expenses</span><strong>{{ money(metric('expenses')) }}</strong>
            </article>
            <article>
              <span>New products</span
              ><strong>{{
                number(metric('products.created') + metric('products.used.created'))
              }}</strong>
            </article>
            <article>
              <span>Customers</span><strong>{{ number(metric('customers.created')) }}</strong>
            </article>
            <article>
              <span>Businesses</span><strong>{{ number(metric('businesses.created')) }}</strong>
            </article>
            <article>
              <span>Chat messages</span><strong>{{ number(metric('chat.messages')) }}</strong>
            </article>
            <article>
              <span>Notifications</span
              ><strong>{{ number(metric('notifications.created')) }}</strong>
            </article>
          </div>
          <section class="table-card">
            <div>
              <p>Daily performance</p>
              <h2>Revenue, spend and order movement</h2>
            </div>
            <div class="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Revenue</th>
                    <th>Purchases</th>
                    <th>Expenses</th>
                    <th>Orders</th>
                    <th>Net cash movement</th>
                  </tr>
                </thead>
                <tbody>
                  @for (row of daily(); track row.date) {
                    <tr>
                      <td>{{ row.date }}</td>
                      <td class="positive">{{ money(row.revenue) }}</td>
                      <td>{{ money(row.purchases) }}</td>
                      <td>{{ money(row.expenses) }}</td>
                      <td>{{ number(row.orders) }}</td>
                      <td [class.negative]="row.revenue - row.purchases - row.expenses < 0">
                        {{ money(row.revenue - row.purchases - row.expenses) }}
                      </td>
                    </tr>
                  } @empty {
                    <tr>
                      <td colspan="6" class="empty">No reporting data for this period.</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </section>
        } @else {
          <section class="focused-summary">
            <div class="focus-icon">
              <span class="material-symbols-outlined">{{ selectedReport().icon }}</span>
            </div>
            <div>
              <span>Total {{ selectedReport().label }}</span
              ><strong>{{ selectedValue(selectedTotal()) }}</strong
              ><small>{{ from }} to {{ to }}</small>
            </div>
          </section>
          <section class="table-card">
            <div>
              <p>{{ selectedReport().label }} report</p>
              <h2>Daily {{ selectedReport().label.toLowerCase() }} activity</h2>
            </div>
            <div class="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>{{ selectedReport().label }}</th>
                  </tr>
                </thead>
                <tbody>
                  @for (row of selectedDaily(); track row.date) {
                    <tr>
                      <td>{{ row.date }}</td>
                      <td class="positive">{{ selectedValue(row.value) }}</td>
                    </tr>
                  } @empty {
                    <tr>
                      <td colspan="2" class="empty">
                        No {{ selectedReport().label.toLowerCase() }} data for this period.
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </section>
        }
      }
    </main>
  </div>
</section>
